// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"23":"70524a16","201":"bd8d2b43","361":"d67388d6","981":"b85dfa4f"}[chunkId] + ".css";
};